import React from 'react'
import Modal from '@material-ui/core/Modal';
import style from 'style/ModalMenu.css';
import StarRatingComponent from 'react-star-rating-component';
import StarRoundedIcon from '@material-ui/icons/StarRounded';
import { Button } from '@material-ui/core';
import Loading from 'components/Loading'




class ModalRater extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      rating: 0,
      comment: '',
      showLoading: false
    }
  }
  handleClose = () => {
    this.setState({ open: false, comment: '', rating: 0 })
  }

  openModal = () => {
    this.setState({ open: true })
  }

  onStarClick = (nextValue, prevValue, name) => {
    this.setState({ rating: nextValue });
  }

  onSubmitRate = async () => {
    this.showLoading()
    await this.props.onSubmitRate(this.state.rating, this.state.comment)
    this.hideLoading()
    this.handleClose()
  }

  showLoading = () => {
    this.setState({ showLoading: true })
  }
  hideLoading = () => {
    this.setState({ showLoading: false })
  }

  handleChange = e => this.setState({ comment: e.target.value })

  render() {
    return (
      <Modal

        open={this.state.open}
      // onClose={this.handleClose}
      >
        <div className="modal-menu" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', borderRadius: 4 }}>
          <div style={{ textAlign: 'center', fontSize: '14px' }}>میزان رضایتمندی خود از مشاوره را در بخش زیر مشخص نمایید</div>
          <StarRatingComponent
            name="rateInput"
            starColor={'#1dc37e'}
            emptyStarColor={'#ccc'}
            renderStarIcon={() => <StarRoundedIcon style={{ fontSize: '40px' }}></StarRoundedIcon>}
            starCount={5}
            value={this.state.rating}
            onStarClick={this.onStarClick}
          />
          <textarea placeholder="نظر خود را بنویسید..." value={this.state.comment} rows="7" onChange={this.handleChange} />
          <div className="modal-action" style={{ marginTop: 16 }}>
            {this.state.showLoading && <div className="Loading"><Loading /></div>}
            <Button onClick={this.handleClose}>انصراف</Button>
            <Button onClick={this.onSubmitRate} style={{ background: '#1dc37e', color: '#fff', padding: '6px 42px' }}>ثبت امتیاز</Button>
          </div>

        </div>
      </Modal>
    )
  }
}
export default ModalRater